export default "__VITE_ASSET__mtBuKaP3__"